import { DateTime } from "luxon";



/**
 * Converte un ISO (UTC) in string locale, usando il fuso passato.
 * Se l’ISO non termina con "Z" lo forziamo a UTC.
 */
export function formatUtcToTz(isoUtc, tz) {
  if (!isoUtc) return "";
  const fixedIso = isoUtc.endsWith("Z") ? isoUtc : isoUtc + "Z";
  const dateObj  = new Date(fixedIso);        // sempre UTC

  return new Intl.DateTimeFormat("it-IT", {
    timeZone: tz,
    day:    "2-digit",
    month:  "2-digit",
    hour:   "2-digit",
    minute: "2-digit",
  }).format(dateObj);
}
